module.exports = __webpack_public_path__ + "img/fx1.dfb190f3.png";